import { Modal } from '@codametrix/ui-components';
import React from 'react';
import './styles/index.scss';
const CancelledEula: React.FC<CMxCommonApp.CancellableEulaProps> = (
  props: CMxCommonApp.CancellableEulaProps
) => {
  const { onEulaCancel, modalProps } = props;

  const submitClick = (e: any) => {
    onEulaCancel(false);
  };
  return (
    <div className={'qa-cancelled-eula'}>
      <Modal
        title={'You must accept the EULA to use the application'}
        buttonText={'Return'}
        closable={false}
        onSubmit={submitClick}
        forceSubmitOptions={{
          isForced: true,
          time: 10,
          message: 'Returning to the login screen '
        }}
        {...modalProps}>
        <p>Please review the EULA and try again.</p>
      </Modal>
    </div>
  );
};
CancelledEula.displayName = 'CancelledEula';

export default CancelledEula;
